import PropTypes from 'prop-types'
import { Heading } from '@pretamanger/component-library'
import Translation from '#src/common/components/translation/'
import { DisclaimerPanel } from './styles'

const Disclaimer = ({ className, children }) => (
  <DisclaimerPanel type='info' className={className}>
    <Heading data-testid='product-disclaimer' level='h2' className='sr-only'>
      <Translation id='product.disclaimer-title' />
    </Heading>
    {children}
    <Translation id='product.disclaimer' />
  </DisclaimerPanel>
)

Disclaimer.defaultProps = {
  className: ''
}

Disclaimer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

export default Disclaimer
